<template>
  <div @click="selectImage" class="relative">
    <van-image :src="userAvatar" round :width="size" :height="size" fit="cover">
    </van-image>
    <van-image v-if="showIcon" :src="require('@/assets/icons/v2/icon_change_avatar.svg')" width="24" height="24"
        class="absolute bottom-2 right-2"/>

  </div>
</template>

<script>
import { Toast } from "vant";
import user from "@/api/user";
import { mapState } from "vuex";

export default {
  name: "Avatar",
  props: {
    showIcon: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 104
    },
    updateProfile: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      userAvatar: ""
    };
  },
  methods: {
    selectImage() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = async e => {
        const file = e.target.files[0];
        if (file) {
          const selectedImage = URL.createObjectURL(file);
          try {

            const formData = new FormData();
            formData.append("file", file);
            Toast.loading("Uploading");
            const avatarUrl = await user.uploadFile(formData);
            if (this.updateProfile) {
              await user.updateUserProfile({ picture: avatarUrl });
              const userInfo = { ...this.userInfo };
              userInfo.picture = avatarUrl;
              this.$store.commit("user/setLoginInfo", userInfo);
            }
            this.userAvatar = selectedImage;
            this.$emit("change", { selectedImage, avatarUrl });

          } catch (err) {
            Toast.fail("Upload avatar fail!" + err);
          }
        }
      };
      input.click();
    }
  },
  computed: {
    ...mapState("user", ["userInfo"])
  },
  watch: {
    "userInfo.picture": {
      handler: val => {
        this.userAvatar = val
      }
    }
  },
  mounted() {
    this.userAvatar = this.userInfo.picture;
  }
};
</script>
<style scoped lang="less">

</style>